"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hspasteConfig = exports.PASTE_SETTINGS = void 0;
var PASTE_SETTINGS = 'hsPaste';
exports.PASTE_SETTINGS = PASTE_SETTINGS;
var hspasteConfig = {
  FORMAT_TRANSFORM_MAP: 'pasteFormatTransformMap',
  CLEAR_ALL_STYLES: 'pasteClearAllStyles',
  DEFAULT_STYLES_MAP: 'pasteDefaultStylesMap',
  EMBED_URL_PASTING: 'pasteEmbedUrls'
};
exports.hspasteConfig = hspasteConfig;